import type { CSSProperties } from 'react';
import TransparentCharacterImage from './TransparentCharacterImage';
import {robotColorFilter} from '../character/robotPalette';
import {getRobotVariant} from '../character/robotGallery';
import type { CharacterAppearance } from '../types';
import type { CharacterRuntimeState } from '../character/runtime';

type Props={appearance:CharacterAppearance;runtimeState?:CharacterRuntimeState};
const palette:Record<string,string>={
  Green:'#69ed86',Aqua:'#50e4d4',Blue:'#58b7ff',Pink:'#ff8fc2',
  Purple:'#b29bff',Orange:'#ffae59',Red:'#ff737d',Monochrome:'#d9e2eb'
};

/** Official reference art. The previous geometry-only SVG was not an approved character. */
export default function DefaultAgentRobot({appearance,runtimeState='idle'}:Props) {
  const female=appearance.gender==='Feminine';
  const color=palette[appearance.accentColor|| (female?'Pink':'Green')]||palette.Green;
  const fallbackSrc=female?'/character-assets/default-agent-female.webp':'/character-assets/default-agent-male.webp';
  const selected=getRobotVariant(appearance.robotVariantId);
  const portrait=selected&&!selected.requiresBrandCleanup?selected:undefined;
  const src=portrait?.src||fallbackSrc;
  const devices=['Tablet','Phone','Laptop'];
  const held=runtimeState==='working'?appearance.device:appearance.prop;
  const prop=held||'Tablet';
  const otherChoices=[
    appearance.eyewear&&appearance.eyewear!=='None'?appearance.eyewear+' glasses':null,
    appearance.audio==='Headphones'?'Headphones':null,
    appearance.backAccessory&&appearance.backAccessory!=='None'?appearance.backAccessory:null,
    appearance.companion==='Mini Drone'?'Mini drone':null,
    prop!=='None'&&prop!=='Tablet'?prop:null
  ].filter(Boolean) as string[];
  return <div className={'reference-agent-art reference-agent-'+(female?'female':'male')} style={{'--agent-reference-accent':color} as CSSProperties}>
    <span className="reference-agent-light" aria-hidden="true" />
    <TransparentCharacterImage src={src} fallbackSrc={fallbackSrc} alt="" className="reference-agent-img" style={{filter:portrait?undefined:robotColorFilter(appearance.accentColor)}} draggable={false} />
    {otherChoices.length>0&&<span className="reference-agent-equipped" aria-label={'Selected accessories: '+otherChoices.join(', ')}>
      {otherChoices.map(item=><span key={item}>{item}</span>)}
    </span>}
    <span className="reference-agent-status" data-state={runtimeState}>{runtimeState.replaceAll('_',' ')}</span>
  </div>;
}
